import { supabase } from './supabase'

/**
 * Migration utility to move data from localStorage to Supabase
 * Run this once after setting up Supabase
 */
export async function migrateLocalStorageToSupabase() {
  try {
    // Get data from localStorage
    const projectsJson = localStorage.getItem('projects')
    const projectsPageJson = localStorage.getItem('projectsPageData')

    if (!projectsJson && !projectsPageJson) {
      console.log('No data found in localStorage to migrate')
      return { success: false, message: 'No data to migrate' }
    }

    let migratedProjects = 0
    let migratedProjectsPage = 0

    // Migrate projects (Work section)
    if (projectsJson) {
      const projects = JSON.parse(projectsJson)

      // Transform data to match Supabase schema
      const projectsData = projects.map((p: any, index: number) => ({
        title: p.title,
        category: Array.isArray(p.category) ? p.category : [p.category],
        year: p.year,
        image: p.image,
        thumbnail: p.thumbnail,
        media_type: p.mediaType || 'image',
        description: p.description,
        position: index,
      }))

      const { error } = await supabase.from('projects').insert(projectsData)

      if (error) {
        console.error('Error migrating projects:', error)
        return { success: false, message: error.message }
      }

      migratedProjects = projectsData.length
    }

    // Migrate projects page data
    if (projectsPageJson) {
      const projectsPage = JSON.parse(projectsPageJson)

      // Transform data to match Supabase schema
      const projectsPageData = projectsPage.map((p: any, index: number) => ({
        title: p.title,
        description: p.description,
        image: p.image,
        link: p.link,
        category: p.category,
        button_text: p.buttonText || 'View Project',
        button_disabled: p.buttonDisabled || false,
        position: index,
      }))

      const { error } = await supabase
        .from('projects_page')
        .insert(projectsPageData)

      if (error) {
        console.error('Error migrating projects page:', error)
        return { success: false, message: error.message }
      }

      migratedProjectsPage = projectsPageData.length
    }

    console.log(`✅ Migration successful!`)
    console.log(`   - Migrated ${migratedProjects} work projects`)
    console.log(`   - Migrated ${migratedProjectsPage} projects page items`)

    return {
      success: true,
      message: `Migrated ${migratedProjects} work projects and ${migratedProjectsPage} projects page items`,
    }
  } catch (error) {
    console.error('Migration error:', error)
    return { success: false, message: String(error) }
  }
}
